import { DevBoxActionActionType, DevBoxActionSourceTypeContract } from '../data/contracts/dev-box-action';
import { DevBoxAction, DevBoxActionName } from '../models/dev-box-action';
import { getHoursBetweenDates } from './time';

const isDevBoxScheduleSourceId = (sourceId: string): boolean => {
    // Delete Action is returned even when feature flag is disabled, it doesn't have a sourceId which leads to errors here
    if (sourceId === undefined) {
        return false;
    }

    // The source id for the dev box default schedule looks like '/projects/{projectName}/pools/{poolName}/schedules/default'
    const parts = sourceId.split('/');

    try {
        if (parts.length !== 7) {
            return false;
        }

        if (parts[5] === 'schedules' && parts[6] === 'default') {
            return true;
        }
    } catch (error) {
        console.error(error);
        return false;
    }

    return false;
};

export const isDevBoxScheduleAction = (devBoxAction: DevBoxAction): boolean =>
    devBoxAction.actionType === DevBoxActionActionType.Stop && isDevBoxScheduleSourceId(devBoxAction.sourceId);

export const isDevBoxStopOnDisconnectAction = (devBoxAction: DevBoxAction): boolean =>
    devBoxAction.actionType === DevBoxActionActionType.Stop && devBoxAction.name === DevBoxActionName.StopOnDisconnect;

// [TODO]: 2399791 - mflemming - should be using Delete actionType but latest beta client doesn't return it
export const isDevBoxScheduleDeleteAction = (devBoxAction: DevBoxAction): boolean =>
    devBoxAction.sourceType === DevBoxActionSourceTypeContract.Admin &&
    devBoxAction.name === DevBoxActionName.DeleteByAdmin;

export const isDevBoxActionWithin24HoursOfTime = (devBoxAction: DevBoxAction, time: Date): boolean => {
    const { next } = devBoxAction;

    if (!next) {
        return false;
    }

    const hoursBetweenDates = getHoursBetweenDates(time, next.scheduledTime);

    return hoursBetweenDates !== undefined && hoursBetweenDates < 24;
};
